<template>
    <el-dialog title="售后报单表" :visible="visibleAfterSales" width="80%" @close="closeDialog" :close-on-click-modal="false"
        height="600px" append-to-body>
        <el-form :model="info" ref="infoForm" label-width="120px" :rules="rules">
            <div slot="header" class="clearfix">
                <span>售后报单信息:</span>
            </div>
            <el-row>
                <el-col :span="12">
                    <!-- 客户信息 -->
                    <el-form-item label="客户姓名" prop="contactsName">
                        <el-input v-model="info.contactsName"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="客户手机号" prop="contactsMobile">
                        <el-input v-model="info.contactsMobile"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="客户地址" prop="customAddress">
                        <el-input v-model="info.customAddress"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <!-- 动态表格 -->
            <el-row>
                <el-col :span="24">
                    <el-form-item label="售后服务">
                        <el-table :data="productFaults" border style="width: 100%">
                            <el-table-column label="服务名称" width="150">
                                <template #default>
                                    <span>防水服务</span>
                                </template>
                            </el-table-column>
                            <!-- 是否提货delivery：0是1否,必填 -->
                            <el-table-column label="是否提货" prop="delivery" width="150">
                                <template #default="{ row }">
                                    <el-radio-group v-model="row.delivery">
                                        <el-radio label="0">是</el-radio>
                                        <el-radio label="1">否</el-radio>
                                    </el-radio-group>
                                </template>
                            </el-table-column>
                            <!-- 如果选择0是提货才必须选择前仓 -->
                            <el-table-column label="前仓" prop="warehouseId" width="180">
                                <template #default="{ row }">
                                    <el-select v-if="row.delivery == '0'" v-model="row.warehouseId" placeholder="请选择前仓"
                                        clearable>
                                        <el-option v-for="item in WarehouseList" :key="item.id"
                                            :label="item.warehouseName" :value="item.id">
                                        </el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column label="工程师" prop="engineerId" width="200">
                                <template #default="{ row }">
                                    <el-select v-model="row.engineerId" placeholder="请选择工程师" filterable remote
                                        :remote-method="handleRemote" clearable>
                                        <el-option v-for="item in users" :key="item.id" :label="item.realName"
                                            :value="item.id">
                                        </el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column label="故障图片" width="200">
                                <template #default="{ row }">
                                    <ImageUpload action="#" :multiple="true" :inTable="true" :limit="5"
                                        @uploaded="(urls) => handleUploaded(urls, row)"
                                        :uploaded-images="row.faultPhotos" />
                                </template>
                            </el-table-column>
                            <!-- 故障视频 -->
                            <el-table-column label="故障视频" width="180">
                                <template #default="{ row }">
                                    <videoAndFileUpload action="#" :multiple="false" :limit="1"
                                        @uploaded="(urls) => handleUploadVideo(urls, row)"
                                        :uploaded-images="row.faultVideos" />
                                </template>
                            </el-table-column>
                            <el-table-column label="故障现象说明">
                                <template #default="{ row }">
                                    <el-input type="textarea" v-model="row.faultPhenomenon">
                                    </el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="150">
                                <template #default="{ row, $index }">
                                    <el-button type="text" size="small" @click="removeRow($index)" icon="el-icon-delete">
                                        删除
                                    </el-button>
                                    <el-button type="text" size="small" @click="addRow" icon="el-icon-plus">
                                        新增
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div style="margin-top: 10px; text-align: right;" v-show="productFaults.length == 0">
                            <el-button type="primary" size="small" @click="addRow">新增</el-button>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button type="danger" size="small" @click="closeDialog" icon="el-icon-close">取消</el-button>
            <el-button type="primary" size="small" @click="submit" icon="el-icon-upload">提交</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { getMerchantOrder, addAfterSaleOrder } from "@/api/work/waterProof/merchants";
import { findUserList } from "@/api/work/projectService";
import ImageUpload from "@/components/imageUpload/ImageUpload";
import videoAndFileUpload from "@/components/videoAndFileUpload/videoAndFileUpload";
export default {
    name: "WaterProofAfterSales",
    props: {
        visibleAfterSales: {
            type: Boolean,
            required: true,
        },
        afterSalesId: {
            type: [String, Number],
            required: true,
        },
        WarehouseList: {
            type: Array,
            required: true,
        },
    },
    components: {
        ImageUpload,
        videoAndFileUpload
    },
    data() {
        return {
            productFaults: [this.getInitialProductFault()],
            info: this.getInitialInfo(),
            users: [],
            rules: {
                contactsName: [{ required: true, message: "请输入客户姓名", trigger: "blur" }],
                contactsMobile: [{ required: true, message: "请输入客户手机号", trigger: "blur" }],
                customAddress: [{ required: true, message: "请输入客户地址", trigger: "blur" }],
            }
        };
    },
    created() {
        if (this.afterSalesId) {
            this.loadData();
        }
    },
    watch: {
        visibleAfterSales(newVal) {
            if (newVal && this.afterSalesId) {
                this.loadData();
            }
        },
    },
    methods: {
        getInitialProductFault() {
            return {
                delivery: "",
                warehouseId: "",
                faultPhotos: [],
                faultPhenomenon: "",
                faultVideos: [],
                engineerId: "",
            };
        },
        getInitialInfo() {
            return {
                declarationId: "",
                contactsName: "",
                contactsMobile: "",
                customAddress: "",
            };
        },
        submit() {
            this.$refs.infoForm.validate(async (valid) => {
                if (!valid) {
                    this.$message.error("请完善基本信息");
                    return;
                }

                if (this.productFaults.length == 0) {
                    this.$message.error("请添加售后服务记录");
                    return;
                }

                try {
                    const payload = {
                        declarationId: this.info.declarationId,
                        contactsName: this.info.contactsName,
                        contactsMobile: this.info.contactsMobile,
                        customAddress: this.info.customAddress,
                        goods: this.productFaults.map(row => ({
                            goodsName: "防水服务",
                            delivery: row.delivery,
                            warehouseId: row.delivery === '0' ? row.warehouseId : '',
                            faultPhotos: row.faultPhotos.map(item => item.url).join(','),
                            faultPhenomenon: row.faultPhenomenon,
                            videoUrl: row.faultVideos.map(item => item.url).join(','),
                            engineerId: row.engineerId
                        }))
                    };
                    console.log('payload::: ', payload);

                    const res = await addAfterSaleOrder(payload);
                    if (res.code !== '200') {
                        throw new Error(res.message);
                    }

                    this.$message.success("提交成功");
                    this.closeDialog();
                } catch (error) {
                    this.$message.error(error.message || "提交失败");
                }
            });
        },
        handleRemote(query) {
            if (this.remoteTimeout) {
                clearTimeout(this.remoteTimeout);
            }

            this.remoteTimeout = setTimeout(() => {
                // eslint-disable-next-line no-control-regex
                const isChineseChar = /[^\x00-\xff]/.test(query);
                const isValidMobile = /^\d{8,}$/.test(query);

                if (isChineseChar || isValidMobile) {
                    this.users = [];
                    const params = {
                        type: "JOINS_ENGINEER",
                        mobile: query,
                    };

                    findUserList(params).then((res) => {
                        if (res.code === "200") {
                            this.users = JSON.parse(res.data);
                        } else {
                            this.$message.error(res.message);
                        }
                    });
                }
            }, 200);
        },
        closeDialog() {
            this.productFaults = [this.getInitialProductFault()];
            this.info = this.getInitialInfo();
            this.$emit("update:visibleAfterSales", false);
        },
        handleUploaded(urls, row) {
            row.faultPhotos = urls;
        },
        handleUploadVideo(urls, row) {
            row.faultVideos = urls;
        },
        loadData() {
            getMerchantOrder(this.afterSalesId).then(res => {
                if (res.code === "200") {
                    const data = JSON.parse(res.data).rows[0];
                    this.info = {
                        contactsMobile: data.customMobile,
                        contactsName: data.customName,
                        declarationId: data.id,
                        customAddress: data.customAddress,
                    };
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: "error"
                    });
                }
            });
        },
        addRow() {
            this.productFaults.push(this.getInitialProductFault());
        },
        removeRow(index) {
            this.productFaults.splice(index, 1);
        },
    }
};
</script>


<style scoped>
.el-row {
    margin-bottom: 20px;
}

.el-row:last-child {
    margin-bottom: 0;
}

.el-col {
    border-radius: 4px;
}

.dialog-footer {
    text-align: right;
}
</style>
